import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface IAdvancingRecipientsProps {
  participants: server.dto.AdvancingParticipant[]
}

const AdvancingRecipients = (props: IAdvancingRecipientsProps) => {
  if (props.participants && props.participants.filter((r) => !r.isDeleted).length > 0) {
    return <div> {
      props.participants.map((invitation, index) => {
        if (invitation.isDeleted) {
          return null;
        }
        if (invitation.hasAccepted) {
          return <React.Fragment key={invitation.id}>
            {site.deploymentValues.debug && <span key={index}><a href={routes.advancing_InvitationLanding(invitation.secret).absolute} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>{invitation.acceptedBy.fullName}</a></span>}
            {!site.deploymentValues.debug && <span key={index}>{invitation.acceptedBy.fullName}</span>}
          </React.Fragment>;
        } else {
          return <React.Fragment key={invitation.id}>
            {site.deploymentValues.debug && <span key={index}><a href={routes.advancing_InvitationLanding(invitation.secret).absolute} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>{invitation.email}</a></span>}
            {!site.deploymentValues.debug && <span key={index} className="s1_gray">{invitation.email}</span>}
          </React.Fragment>;
        }
      }).reduce((accu, elem) => {
        if (elem === null) {
          return accu;
        }
        return accu === null ? [elem] : [accu, ", ", elem];
      }, null)
    }
    </div >;
  }

  return <span className="red">{RESX.Advancing.NoParticipantsInvited}</span>;
};

export default AdvancingRecipients;
